import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import PropTypes from 'prop-types';


class EventsDropdown extends Component {
  constructor(props) {
    super(props);

    this.onWindowClick = this.onWindowClick.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.show = this.show.bind(this);

    this.state = {
      open: false,
      selectedId: null
    };
  }

  componentDidMount() {
    window.addEventListener('click', this.onWindowClick);
    window.addEventListener('touchstart', this.onWindowClick);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.onWindowClick);
    window.removeEventListener('touchstart', this.onWindowClick);
  }

  onWindowClick(e) {
    const { open } = this.state;
    const dropdownElement = findDOMNode(this);
    if (e.target !== dropdownElement && !dropdownElement.contains(e.target) && open) {
      this.hide();
    }
  }

  handleToggle() {
    this.setState(prevState => ({
      open: !prevState.open
    }));
  }

  handleSelect(id) {
    const { onSelect } = this.props;
    this.setState({
      open: false,
      selectedId: id
    });
    onSelect(id);
  }

  show() {
    this.setState({
      open: true
    });
  }

  hide() {
    this.setState({
      open: false
    });
  }

  render() {
    const { options } = this.props;
    const { open, selectedId } = this.state;

    return (
      <div className="events-dropdown">
        <div onClick={this.handleToggle}>
          <div className={`form-control${open ? ' expanded' : ''}`}>
            {selectedId ? options.byId[selectedId].label : 'Select an Event'}
          </div>
          <i className={`zolaicon zolaicon-chevron${open ? '-up' : '-down'}`} />
        </div>
        <div className={`dropdown-options${open ? ' expanded' : ''}`}>
          {options.orderedIds.filter(id => (id !== selectedId)).map(id => (
            <div key={id} className="option" onClick={() => this.handleSelect(id)}>
              {options.byId[id].label}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

EventsDropdown.propTypes = {
  options: PropTypes.shape({
    byId: PropTypes.shape({
      value: PropTypes.any,
      label: PropTypes.string,
    }),
    orderedIds: PropTypes.arrayOf(PropTypes.number)
  }),
  onSelect: PropTypes.func,
};

export default EventsDropdown;



/** WEBPACK FOOTER **
 ** ./src/components/common/modals/MultipleEventsMigrationModal/EventsDropdown.jsx
 **/